<template>
    <li class="annotation-container">
        <!-- Display the parent annatation -->
        <div class="flex-row mb-3">
            <avatar :avatar="data.avatar" size="medium" />
            <div class="ml-2 wp-10">
                <p class="info">
                    <span class="name"
                        ><a :href="'/staff/' + data.owner" class="link">{{
                            data.ownerName
                        }}</a></span
                    >
                    <span class="time gray-60 fs-2">{{
                        data.timestamp | dateFormatter('SLASHED_DATE_TIME')
                    }}</span>
                </p>
                <p v-if="!fulltText" class="m-0">
                    <span
                        class="content wordbreak gray-60 editor-preview rich-text-style"
                        v-html="annotationHTMLFormattedContentTruncated"
                    ></span>
                    <a
                        v-if="data.content.length > 256"
                        @click.stop="fulltText = true"
                        class="link"
                        >{{ $l10n.__('Afficher la suite') }}</a
                    >
                </p>
                <p
                    v-else
                    class="m-0 content wordbreak gray-60 editor-preview rich-text-style"
                    v-html="annotationHTMLFormattedContent"
                ></p>
                <!-- Related name and link for overview -->
                <div v-if="data.relatedName">
                    <p class="grey fs-2">
                        {{ $l10n.__('Lié à : ') }}
                        <span
                            v-if="data.type == 'task'"
                            class="link fs-2 regular"
                            @click="taskLink(data)"
                            >{{ data.relatedName }}</span
                        >
                        <a v-else class="link fs-2 regular" :href="data.relatedLink">{{
                            data.relatedName
                        }}</a>
                    </p>
                </div>
            </div>
        </div>

        <!-- Display the reply -->
        <div v-if="data.reply">
            <!-- link for view allAnnot -->
            <div v-if="data.reply.length > 2">
                <a
                    class="link dinlineb ml-3 mb-3 fs-2"
                    @click.prevent="toggleAllAnnot()"
                    v-html="
                        !displayAllAnnot
                            ? $t.__('dashboard.cards.Annotation.see_more_answers')
                            : $t.__('dashboard.cards.Annotation.see_less_answers')
                    "
                ></a>
            </div>

            <!-- FIRST 2 ANNOTATIONS -->
            <ul v-if="!displayAllAnnot">
                <li v-for="reply in last2annot" :key="reply.id">
                    <div class="reply flex-row pl-3 mb-3">
                        <avatar :avatar="reply.avatar" size="medium" />
                        <div class="ml-2 wp-10">
                            <p class="info">
                                <span class="name"
                                    ><a :href="'/staff/' + reply.owner" class="link">{{
                                        reply.ownerName
                                    }}</a></span
                                >
                                <span class="time gray-60 fs-2">{{
                                    reply.timestamp | dateFormatter('SLASHED_DATE_TIME')
                                }}</span>
                            </p>
                            <p
                                class="content my-1 wordbreak editor-preview rich-text-style"
                                v-html="formatContentToHTML(reply.content)"
                            ></p>
                        </div>
                    </div>
                </li>
            </ul>

            <!-- ALL ANNOTATIONS -->
            <ul v-else>
                <li v-for="reply in data.reply" :key="reply.id">
                    <div class="reply flex-row pl-3 mb-3">
                        <avatar :avatar="reply.avatar" size="medium" />
                        <div class="ml-2 wp-10">
                            <p class="info">
                                <span class="name"
                                    ><a :href="'/staff/' + reply.owner" class="link">{{
                                        reply.ownerName
                                    }}</a></span
                                >
                                <span class="time gray-60 fs-2">{{
                                    reply.timestamp | dateFormatter('SLASHED_DATE_TIME')
                                }}</span>
                            </p>
                            <p
                                class="content my-1 wordbreak editor-preview rich-text-style"
                                v-html="formatContentToHTML(reply.content)"
                            ></p>
                        </div>
                    </div>
                </li>
            </ul>
        </div>

        <!-- Input for reply -->
        <RichText
            v-model="reply.annot_text"
            :placeholder="$t.__('common.actions.answer')"
            :options="optionsRichText"
            class="custom-richtext"
        />
        <div class="aright mt-2 mb-3">
            <a
                class="link"
                :class="reply.annot_text.length == '' ? 'hidden' : ''"
                type="primary"
                @click="save(currentTab)"
                >{{ $l10n.__('Enregistrer') }}</a
            >
        </div>
    </li>
</template>

<script>
import Avatar from 'vcomponents/utilities/Avatar.vue';
import { truncateHTML } from 'js/vue/helpers/truncateHTML.js';
import RichText from 'vcomponents/richtext/RichText.vue';

export default {
    components: {
        Avatar,
        RichText,
    },
    props: {
        data: {
            type: Object,
        },
        currentTab: {
            type: String,
            required: false,
            default: '',
        },
    },
    data() {
        return {
            reply: {
                annot_text: '',
                annot_relatedid: this.data.relatedid,
                annot_relatedtype: this.data.type,
                annot_parentid: this.data.id,
            },
            displayAllAnnot: false,
            fulltText: false,
            optionsRichText: [
                'Heading',
                'Bold',
                'Italic',
                'Underline',
                'Color',
                'Highlight',
                'BulletList',
                'OrderedList',
                'Divider',
                'Link',
                'Mention',
            ],
        };
    },
    computed: {
        last2annot() {
            return this.data.reply.slice(-2);
        },
        annotationHTMLFormattedContent() {
            const content = $('<div>' + this.data.content + '</div>');
            content.find('span.mention[data-id]').each((i, o) => {
                return $(o).wrap(
                    `<a href='/staff/${$(o).attr(
                        'data-id',
                    )}' class='link black semibold' target='_blank'></a>`,
                );
            });
            return content.html();
        },
        annotationHTMLFormattedContentTruncated() {
            return truncateHTML(this.annotationHTMLFormattedContent);
        },
    },

    watch: {
        data: {
            handler: function (newValue) {
                // ugly but fix the parentid not update..
                this.reply.annot_parentid = newValue.id;
            },
            deep: true,
        },
    },

    methods: {
        save(tab) {
            this.$emit('save-annotation', this.reply, tab);
            this.reply.annot_text = '';
        },

        toggleAllAnnot() {
            this.displayAllAnnot = !this.displayAllAnnot;
        },

        taskLink(data) {
            return Agenda.cardForm(
                data.relatedid,
                0,
                'task',
                '',
                '',
                '',
                '',
                'N',
                data.relatedtype,
            );
        },
        formatContentToHTML(contentToEdit) {
            const content = $('<div>' + contentToEdit + '</div>');
            content.find('span.mention[data-id]').each((i, o) => {
                return $(o).wrap(
                    `<a href='/staff/${$(o).attr(
                        'data-id',
                    )}' class='link black semibold' target='_blank'></a>`,
                );
            });
            return content.html();
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~@sellsy/styleguide/src/_variables';
@import '~@sellsy/styleguide/src/_mixins';

.url {
    cursor: pointer;

    &:hover {
        color: $primary-50 !important;
    }
}

.info {
    width: 100%;
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
}
</style>
<style lang="scss">
@import '~@sellsy/styleguide/src/_variables';
.card-annotation {
    .content a {
        color: $primary-50;
    }
}
.annotation-container {
    .custom-richtext {
        min-width: fit-content;
    }
}
</style>
